<template lang="pug">
  .card
    .container
      .title {{ title }}
      .amount {{ amount }}
    .circle.big
    .circle.small

</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      default: 'Sample Card Text',
      type: String
    },
    amount: {
      default: 0,
      type: Number
    }
  },
  components: {
  },
  data () {
    return {

    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .card {
    width: 33.33%;
    height: 100px;
    background: linear-gradient(15deg, #ff7000, rgb(227, 107, 14));
    border-radius: 10px;
    user-select: none;
    color: white;
    position: relative;
    margin: 0 15px;
  }
  .circle {
    position: absolute;
    left: -30px;
    bottom: -75px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }
  .big {
    height: 150px;
    width: 150px;
  }
  .small {
    height: 120px;
    width: 120px;
  }
  .container {
    padding: 15px 25px;
  }
  .title {
    font-size: 16px;
    line-height: 18px;
  }
  .amount {
    font-weight: bold;
    font-size: 3.1rem;
    line-height: 3.1rem;
  }
</style>
